export function confirmBeforeUploadCopy(dest) {
  const where = dest || "the marketplace";
  return `Brand, guarantees and compliance details require your confirmation and are not automatically completed. Add any missing information before uploading to ${where}.`;
}

export function uploadSourcesCopy() {
  return "Upload a spreadsheet from your webshop, another marketplace like eBay, your supplier, or your Amazon ASINs.";
}
